
export const getPathById = (array, id, idField = 'id') => {
    return Array.isArray(array) ? array?.find((item) => item[idField]?.toUpperCase() === id?.toUpperCase())?.path : array
}